import { useEffect } from 'react';
import { nameTableColumn } from '../constants/nameTableRso';
import { useDispatch, useSelector } from 'react-redux';
import { setHighlightedColumns } from '../store/actions/rsoImportActions';

const usePersoneContainerEffect = (form) => {
  const { getFieldValue, resetFields, getFieldsValue } = form;

  const dispatch = useDispatch();

  const columnLabels = useSelector(
    (state) => state.rsoImportStore.columnLabels
  );

  const columnsAddressStartValue = getFieldValue(
    nameTableColumn.columnsAddressStart
  );
  const columnsAddressEndValue = getFieldValue(
    nameTableColumn.columnsAddressEnd
  );

  useEffect(() => {
    if (!columnsAddressStartValue || !columnsAddressEndValue) return;

    const startIndex = columnLabels.findIndex(
      (item) => item.value === columnsAddressStartValue
    );
    const endIndex = columnLabels.findIndex(
      (item) => item.value === columnsAddressEndValue
    );
    if (endIndex === -1) return;

    const slice = columnLabels
      .slice(startIndex + 1, endIndex)
      .map((item) => item.value);

    const currentValues = getFieldsValue();
    const keysToReset = Object.entries(currentValues)
      .filter(([key, val]) => slice.includes(val))
      .map(([key]) => key);

    if (keysToReset.length > 0) {
      resetFields(keysToReset);
      keysToReset.forEach((key) => dispatch(setHighlightedColumns(key, null)));
    }
  }, [
    columnsAddressStartValue,
    columnsAddressEndValue,
    columnLabels,
    getFieldsValue,
    resetFields,
    dispatch,
  ]);
};

export default usePersoneContainerEffect;
